import { FileReader, FileWriter } from '@/platform'

enum PersonLocation {
    LEFT = 1,
    CENTER = 2,
    RIGHT = 3,
}

class PersonSetting {
    public Id: number = 0
    public Name: string = ''
    public FacePath: string = ''
    public Location: PersonLocation = PersonLocation.LEFT
    public FaceW: number = 0
    public FaceH: number = 0
    public BubblePath: string = ''
    public SendEffect: number = 0
    public EffectMPath: string = ''
    public CustomUINumber: string = ''
    public BuEdgeUp: number = 0
    public BuEdgeDown: number = 0
    public BuEdgeLeft: number = 0
    public BuEdgeRight: number = 0
    public BuSpacUp: number = 0
    public BuSpacDown: number = 0
    public BuSpacLeft: number = 0
    public BuSpacRight: number = 0
    public DialogSpac: number = 0
    public NameAndFaceSpac: number = 0
    public EdgeAndFaceSpac: number = 0
    public Font: string = ''
    public FontSize: number = 0
    public EdgeAndnameSpac: number = 0
    public LineSpace: number = 0
    public NamefontSize: number = 0
    public VoiceHeight: number = 0
    public ObligateString1: string = ''
    public ObligateString2: string = ''

    constructor(reader?: FileReader) {
        if (reader) {
            this.readBin(reader)
        } else {
            this.Id = 0
            this.Name = ''
            this.FacePath = ''
            this.Location = PersonLocation.LEFT
            this.FaceW = 0
            this.FaceH = 0
            this.BubblePath = ''
            this.SendEffect = 0
            this.EffectMPath = ''
            this.CustomUINumber = ''
            this.BuEdgeUp = 0
            this.BuEdgeDown = 0
            this.BuEdgeLeft = 0
            this.BuEdgeRight = 0
            this.BuSpacUp = 50
            this.BuSpacDown = 50
            this.BuSpacLeft = 50
            this.BuSpacRight = 50
            this.DialogSpac = 50
            this.NameAndFaceSpac = 50
            this.EdgeAndFaceSpac = 50
            this.EdgeAndnameSpac = 50   
            this.VoiceHeight = 50
            this.LineSpace = 10
            this.NamefontSize = 18
            this.Font = ''
            this.FontSize = 0
            this.ObligateString1 = ''
            this.ObligateString2 = ''
            this.Font = ''
            this.FontSize = 0
            this.ObligateString1 = ''
            this.ObligateString2 = ''
        }
    }

    readBin(reader: FileReader): void {
        this.Id = reader.readInt()
        this.Name = reader.readString()
        this.FacePath = reader.readString()
        this.Location = reader.readInt()
        this.FaceW = reader.readInt()
        this.FaceH = reader.readInt()

        this.BubblePath = reader.readString()
        this.SendEffect = reader.readInt()
        this.EffectMPath = reader.readString()
        this.CustomUINumber = reader.readString()

        this.BuEdgeUp = reader.readInt()
        this.BuEdgeDown = reader.readInt()
        this.BuEdgeLeft = reader.readInt()
        this.BuEdgeRight = reader.readInt()

        this.BuSpacUp = reader.readInt()
        this.BuSpacDown = reader.readInt()
        this.BuSpacLeft = reader.readInt()
        this.BuSpacRight = reader.readInt()

        this.DialogSpac = reader.readInt()
        this.NameAndFaceSpac = reader.readInt()
        this.EdgeAndFaceSpac = reader.readInt()
        this.Font = reader.readString()
        this.FontSize = reader.readInt()

        this.EdgeAndnameSpac = reader.readInt()
        this.LineSpace = reader.readInt()
        this.NamefontSize = reader.readInt()
        this.VoiceHeight = reader.readInt()
        this.ObligateString1 = reader.readString()
        this.ObligateString2 = reader.readString()

    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Id)
        writer.writeString(this.Name)
        writer.writeString(this.FacePath)
        writer.writeInt(this.Location)
        writer.writeInt(this.FaceW)
        writer.writeInt(this.FaceH)

        writer.writeString(this.BubblePath)
        writer.writeInt(this.SendEffect)
        writer.writeString(this.EffectMPath)
        writer.writeString(this.CustomUINumber)

        writer.writeInt(this.BuEdgeUp)
        writer.writeInt(this.BuEdgeDown)
        writer.writeInt(this.BuEdgeLeft)
        writer.writeInt(this.BuEdgeRight)

        writer.writeInt(this.BuSpacUp)
        writer.writeInt(this.BuSpacDown)
        writer.writeInt(this.BuSpacLeft)
        writer.writeInt(this.BuSpacRight)

        writer.writeInt(this.DialogSpac)
        writer.writeInt(this.NameAndFaceSpac)
        writer.writeInt(this.EdgeAndFaceSpac)
        writer.writeString(this.Font)
        writer.writeInt(this.FontSize)

        writer.writeInt(this.EdgeAndnameSpac)
        writer.writeInt(this.LineSpace)
        writer.writeInt(this.NamefontSize)
        writer.writeInt(this.VoiceHeight)
        writer.writeString(this.ObligateString1)
        writer.writeString(this.ObligateString2)
    }

    readVersionedOui(reader: FileReader): void {
        this.Id = reader.readInt()
        this.Name = reader.readString()
        this.FacePath = reader.readString()
        this.Location = reader.readInt()
        this.FaceW = reader.readInt()
        this.FaceH = reader.readInt()

        this.BubblePath = reader.readString()
        this.SendEffect = reader.readInt()
        this.EffectMPath = reader.readString()
        this.CustomUINumber = reader.readString()

        this.BuEdgeUp = reader.readInt()
        this.BuEdgeDown = reader.readInt()
        this.BuEdgeLeft = reader.readInt()
        this.BuEdgeRight = reader.readInt()

        this.BuSpacUp = reader.readInt()
        this.BuSpacDown = reader.readInt()
        this.BuSpacLeft = reader.readInt()
        this.BuSpacRight = reader.readInt()

        this.DialogSpac = reader.readInt()
        this.NameAndFaceSpac = reader.readInt()
        this.EdgeAndFaceSpac = reader.readInt()
        this.Font = reader.readString()
        this.FontSize = reader.readInt()

        this.EdgeAndnameSpac = reader.readInt()
        this.LineSpace = reader.readInt()
        this.NamefontSize = reader.readInt()
        this.VoiceHeight = reader.readInt()
        this.ObligateString1 = reader.readString()
        this.ObligateString2 = reader.readString()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.Id)
        writer.writeString(this.Name)
        writer.writeString(this.FacePath)
        writer.writeInt(this.Location)
        writer.writeInt(this.FaceW)
        writer.writeInt(this.FaceH)

        writer.writeString(this.BubblePath)
        writer.writeInt(this.SendEffect)
        writer.writeString(this.EffectMPath)
        writer.writeString(this.CustomUINumber)

        writer.writeInt(this.BuEdgeUp)
        writer.writeInt(this.BuEdgeDown)
        writer.writeInt(this.BuEdgeLeft)
        writer.writeInt(this.BuEdgeRight)

        writer.writeInt(this.BuSpacUp)
        writer.writeInt(this.BuSpacDown)
        writer.writeInt(this.BuSpacLeft)
        writer.writeInt(this.BuSpacRight)

        writer.writeInt(this.DialogSpac)
        writer.writeInt(this.NameAndFaceSpac)
        writer.writeInt(this.EdgeAndFaceSpac)
        writer.writeString(this.Font)
        writer.writeInt(this.FontSize)

        writer.writeInt(this.EdgeAndnameSpac)
        writer.writeInt(this.LineSpace)
        writer.writeInt(this.NamefontSize)
        writer.writeInt(this.VoiceHeight)
        writer.writeString(this.ObligateString1)
        writer.writeString(this.ObligateString2)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default PersonSetting
